import {
  SlCollapsibleListComponent,
  TransactionRowComponent,
} from '@varo/graphql-schema-types';
import { isPositiveValue } from 'features/accounts/AccountDetails/AccountDetails.helpers';
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import IconButton from 'shared/components/vxl/icon/IconButton/IconButton';
import TransactionListItem from 'shared/components/vxl/TransactionListItem/TransactionListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodySmBoldText from 'shared/components/vxl/typography/primary/body/BodySmBoldText';
import theme from 'shared/styles/theme';

import HtmlWithActions from './HtmlWithActions/HtmlWithActions';

interface UpcomingTransactionsProps {
  component: SlCollapsibleListComponent;
  handleOnPress: (e: string) => void;
  accountType?: string;
}

const UpcomingTransactions = ({
  component,
  handleOnPress,
  accountType,
}: UpcomingTransactionsProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <View>
      <View style={styles.container}>
        <View style={styles.listDetail}>
          {component?.iconV2 ? (
            <Icon iconKey={component?.iconV2} iconSize="MD" />
          ) : null}
          <BodySmBoldText numberOfLines={0}>
            {component.title.copy}
          </BodySmBoldText>
        </View>
        <View style={styles.listDetail}>
          {component?.secondaryText ? (
            <BodySmBoldText numberOfLines={0} style={styles.daysLeft}>
              {component.secondaryText}
            </BodySmBoldText>
          ) : null}

          <IconButton
            iconOnPress={() => setIsCollapsed(!isCollapsed)}
            iconKey={isCollapsed ? 'CHEVRON_DOWN' : 'CHEVRON_UP'}
            iconButtonAccessibilityLabel="CHEVRON_UP"
            analyticsId="upcomingTransactionAnalytics"
            customAttributes={{ account_type: 'checking' }}
          />
        </View>
      </View>
      {!isCollapsed ? (
        <>
          {component?.children?.map((item: TransactionRowComponent, index) => {
            return (
              <React.Fragment key={`tx-${item.id}`}>
                <TransactionListItem
                  amountStyle={isPositiveValue(item?.primaryDetail?.copy)}
                  isPending={false}
                  amountText={item.primaryDetail.copy}
                  titleText={item.primaryText.copy}
                  balanceText={item?.secondaryDetail?.copy}
                  accessibilityLabel=""
                  banner={{
                    body:
                      item?.callout?.children?.map((c) => c.html).join('') ??
                      '',
                  }}
                  onPress={() => handleOnPress(item?.onClick?.id ?? '')}
                  secondaryText={item?.secondaryText?.copy}
                  analyticsId="transactionViewed"
                  customAttributes={{
                    category: accountType,
                    account_type: accountType,
                  }}
                  isDisabled={true}
                />
                {index > 0 ? (
                  <View style={styles.divider}>
                    <HairLineDivider />
                  </View>
                ) : null}
              </React.Fragment>
            );
          })}

          {component?.footer?.html ? (
            <View style={styles.footer}>
              <BodyBaseText numberOfLines={0}>
                <HtmlWithActions
                  html={component.footer.html}
                  linkActions={component.footer.linkActions}
                />
              </BodyBaseText>
            </View>
          ) : null}
        </>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing.m,
  },
  daysLeft: { color: theme.color.text.secondary },
  divider: { paddingHorizontal: theme.spacing.m },
  footer: {
    backgroundColor: theme.color.background.primary,
    paddingHorizontal: theme.spacing.m,
  },
  listDetail: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing.xs,
  },
});

export default UpcomingTransactions;
